module.exports = __webpack_public_path__ + "static/media/breath.c6c09ca5.png";